import React from "react";
import HeroSection from "../../components/public/HeroSection";
import Differenciation from "../../components/public/Differenciation";
import ClimatisationSection from "../../components/public/ClimatisationSection";
import TestimonialsSection from "../../components/public/TestimonialsSection";
import ServicesSection from "../../components/public/ServicesSection";
import RealisationsSection from "../../components/public/RealisationsSection";
import VideoIntroSection from "../../components/public/VideoIntroSection";
import ZonesSection from "../../components/public/ZonesSection";
import CTASection from "../../components/public/CTASection";
import BrandsSection from "../../components/public/BrandsSection";
import PromoBanner from "../../components/public/PromoBanner";
import ShopCategoriesSection from "../../components/public/ShopCategoriesSection";
import ShopProductsRow from "../../components/public/ShopProductsRow";
import NewsletterSection from "../../components/public/NewsletterSection";
import { useSettings } from "../../lib/useSettings";

const ShopPopularSection = () => <ShopProductsRow variant="popular" testId="shop-popular-section" />;
const ShopPromotionsSection = () => <ShopProductsRow variant="promotions" testId="shop-promotions-section" />;
const ShopNewSection = () => <ShopProductsRow variant="new" testId="shop-new-section" />;

const SECTION_COMPONENTS = {
  promo_banner: PromoBanner,
  hero: HeroSection,
  brands: BrandsSection,
  differentiation: Differenciation,
  climatisation: ClimatisationSection,
  services: ServicesSection,
  shop_categories: ShopCategoriesSection,
  shop_popular: ShopPopularSection,
  shop_promotions: ShopPromotionsSection,
  shop_new: ShopNewSection,
  realisations: RealisationsSection,
  video_intro: VideoIntroSection,
  testimonials: TestimonialsSection,
  zones: ZonesSection,
  newsletter: NewsletterSection,
  cta: CTASection,
};

const DEFAULT_ORDER = [
  "promo_banner",
  "hero", "brands", "differentiation", "climatisation",
  "services",
  "shop_categories", "shop_popular", "shop_promotions", "shop_new",
  "realisations", "testimonials", "zones",
  "video_intro",
  "newsletter", "cta",
];

const SHOP_GATED = new Set(["shop_categories", "shop_popular", "shop_promotions", "shop_new"]);

export default function HomePage() {
  const { settings: s } = useSettings();
  const sector = (s?.sector || "").toLowerCase();
  const climatisationEligible =
    !s?.is_template &&
    (sector.includes("clim") || sector.includes("pompe") || sector.includes("chauff") || sector.includes("froid") || sector === "");
  const shopOn = !!s?.shop_enabled;

  const enabled = s?.home_sections_enabled || {};
  const order = (s?.home_sections_order && s.home_sections_order.length) ? s.home_sections_order : DEFAULT_ORDER;

  return (
    <>
      <title>{s ? `${s.company_name} — ${s.tagline}` : "Site en construction"}</title>
      <meta name="description" content={s?.hero_subtitle || s?.tagline || "Site professionnel."} />
      {order.map((key) => {
        const Comp = SECTION_COMPONENTS[key];
        if (!Comp) return null;
        if (enabled[key] === false) return null;
        if (key === "climatisation" && !climatisationEligible) return null;
        // Shop-dependent blocks require shop_enabled
        if (SHOP_GATED.has(key) && !shopOn) return null;
        return <Comp key={key} />;
      })}
    </>
  );
}
